export default {
  watch: {
    onboardingNecessary: {
      immediate: true,
      handler(val, oldVal) {
        this.$nextTick(() => {
          if (val && oldVal !== val) {
            this.openOnboardingModal();
          }
        });
      },
    },
  },
};
